"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _alloyReactHelpers = require("@adsk/alloy-react-helpers");

var _alloyReactModal = _interopRequireDefault(require("@adsk/alloy-react-modal"));

var _alloyReactIcon = require("@adsk/alloy-react-icon");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _dom = require("../../util/dom");

var _routes = require("../../util/routes");

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

var _alloyReactMenu = _interopRequireDefault(require("@adsk/alloy-react-menu"));

var _mediaDetailContext = require("./media-detail-context");

var _qa = _interopRequireDefault(require("../../util/qa"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Header = (0, _styledComponents.default)(_alloyReactModal.default.Header)`
  font-size: ${_alloyReactTheme.default.typography.heading1.fontSize};
  padding: 0px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ButtonGroup = _styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60px;
`;
const StyledMenu = (0, _styledComponents.default)(_alloyReactMenu.default)`
  left: unset;
  right: 48px;
  top: 48px;
`;
const StyledXIcon = (0, _styledComponents.default)(_alloyReactIcon.XIcon)`
  &:hover {
    cursor: pointer;
  }
`;

const MediaDetailHeader = () => {
  const [menuOpen, setMenuOpen] = (0, _react.useState)(false);
  const {
    state: {
      media
    },
    mediaHandlers
  } = (0, _mediaDetailContext.useMedia)();
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../i18n/${locale}.json`));
  const handleShare = (0, _react.useCallback)(() => {
    const route = `${window.location.origin}${_routes.getRoute.photo(media.uid)}`;
    (0, _dom.copyText)(route);
    mediaHandlers.shareHandler && mediaHandlers.shareHandler(route);
  }, [media, mediaHandlers]);
  return /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, media.title), /*#__PURE__*/_react.default.createElement(ButtonGroup, {
    "data-qa": _qa.default.mediaDetailActionButton
  }, /*#__PURE__*/_react.default.createElement(_alloyReactIcon.MoreHorizontalIcon, {
    color: _alloyReactTheme.default.colors.charcoal700,
    onClick: () => setMenuOpen(!menuOpen)
  }), /*#__PURE__*/_react.default.createElement(StyledXIcon, {
    onClick: mediaHandlers.closeHandler,
    color: _alloyReactTheme.default.colors.charcoal700
  })), menuOpen && /*#__PURE__*/_react.default.createElement(StyledMenu, {
    onClose: () => setMenuOpen(false),
    options: [{
      icon: _alloyReactIcon.ShareIcon,
      key: "share",
      label: T.translate("SHARE"),
      onClick: handleShare
    }, {
      icon: _alloyReactIcon.DownloadIcon,
      disabled: !mediaHandlers.downloadHandler,
      key: "download",
      label: T.translate("DOWNLOAD"),
      onClick: () => mediaHandlers.downloadHandler(media)
    }, {
      icon: _alloyReactIcon.TrashCanIcon,
      disabled: !mediaHandlers.deleteHandler,
      key: "delete",
      label: T.translate("DELETE"),
      onClick: e => mediaHandlers.deleteHandler(media, e)
    }],
    width: 180
  }));
};

var _default = MediaDetailHeader;
exports.default = _default;